import Vue from 'vue'
import VueRouter from 'vue-router'
import VueTagManager from 'vue-tag-manager'
import Vuelidate from 'vuelidate'
import './assets/scss/style.scss'
import App from './App.vue'

export const bus = new Vue()

Vue.config.productionTip = false

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    return window.scrollTo({ top: 0, behavior: 'smooth' })
  }
})
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueTagManager, {
    gtmId: 'GTM-MC4MCHW'
  })
}

Vue.use(Vuelidate)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
